export const presets = {
  blue: {
    bg: "#2B6BED",
    text: "#fff",
    name: "#fff",
    smallText: "#a2a8af",
  },
  green: {
    bg: "#D8F5D2",
    text: "#303943",
    name: "#42803C",
    smallText: "#a2a8af",
  },
  purple: {
    bg: "#EFD9FF",
    text: "#303943",
    name: "#BE9BD9",
    smallText: "#a2a8af",
  },
  yellow: {
    bg: "#F9F4CB",
    text: "#303943",
    name: "#F1EDC5",
    smallText: "#a2a8af",
  },
  grey: {
    bg: "#EDEDED",
    text: "#303943",
    name: "#35393C",
    smallText: "#a2a8af",
  },
}
